window.placeholder_images = {
  ROUND: 'https://cdn.shopify.com/s/files/1/0643/2348/5937/files/ea96671e-cf25-43a2-beba-c4f3181c0a17.png?v=1704714963',
  HEART: 'https://cdn.shopify.com/s/files/1/0643/2348/5937/files/df099659-da59-48fa-9924-e20f351dbe0a.png?v=1704715338',
  PRINCESS: 'https://cdn.shopify.com/s/files/1/0643/2348/5937/files/a36135be-158d-4b72-96ca-08be7efc1f5a.png?v=1704714977',
  CUSHION: 'https://cdn.shopify.com/s/files/1/0643/2348/5937/files/cbee0a1f-fe2e-470a-b9e6-33a9564d6459.png?v=1704715339',
  ASSCHER: 'https://cdn.shopify.com/s/files/1/0643/2348/5937/files/75d2e496-6400-4d0e-88e4-f08fe28dea6f.png?v=1704715338',
  EMERALD: 'https://cdn.shopify.com/s/files/1/0643/2348/5937/files/4305a1df-0ca2-4e7c-abf9-f47144962719.png?v=1704715339',
  OVAL: 'https://cdn.shopify.com/s/files/1/0643/2348/5937/files/9d7a3b1d-442d-4351-a78e-2459f5da33b4.png?v=1704715338',
  PEAR: 'https://cdn.shopify.com/s/files/1/0643/2348/5937/files/Pear_Diamond.png?v=1710782234',
  MARQUISE: 'https://cdn.shopify.com/s/files/1/0643/2348/5937/files/Marquise_Diamond.png?v=1710432710',
  RADIANT: 'https://cdn.shopify.com/s/files/1/0643/2348/5937/files/radiant_diamond.png?v=1704715904',
};

const SortDropdown = class extends HTMLElement {
  constructor() {
    super();

    this.open = false;
    this.button = this.querySelector('.link-dropdown__button');
    this.button.addEventListener('click', this.toggle.bind(this));
    const sortInput = this.querySelector('#diamonds-order');
    const activeLabelE = this.querySelector('.link-dropdown__button-text');
    this.querySelectorAll('.link-dropdown__link').forEach((link) => {
      //get data-value from the link and set it to the input
      // and add class link-dropdown__link--active
      link.addEventListener('click', (evt) => {
        evt.preventDefault();
        sortInput.value = link.dataset.value;
        activeLabelE.textContent = `Sort By: ${link.textContent}`;
        this.querySelector('.link-dropdown__link--active').classList.remove('link-dropdown__link--active');
        link.classList.add('link-dropdown__link--active');
        this.toggle(evt, true);
        sortInput.dispatchEvent(
          new Event('change', {
            bubbles: true,
          })
        );
      });
    });
  }

  connectedCallback() {
    if (this.open) {
      this.addDismissListener();
    }
  }

  disconnectedCallback() {
    if (this.open) {
      this.removeDismissListener();
    }
  }

  toggle(evt, isDismiss) {
    if (!isDismiss) {
      evt.preventDefault();
      evt.stopPropagation();
    }

    if (evt.x == 0) return;

    const doExpand = this.button.getAttribute('aria-expanded') === 'false';
    this.button.setAttribute('aria-expanded', doExpand);
    //this.button.style.width = `${this.button.clientWidth}px`;

    let newWidth = null;
    const optsBox = this.button.nextElementSibling;
    const isLeftAligned = this.button.closest('.link-dropdown').classList.contains('link-dropdown--left-aligned');
    if (!isLeftAligned) {
      if (doExpand) {
        newWidth = optsBox.clientWidth;
        // rtl - could be either side
        if (document.querySelector('html[dir=rtl]')) {
          newWidth += parseInt(getComputedStyle(optsBox).left, 10);
        } else {
          newWidth += parseInt(getComputedStyle(optsBox).right, 10);
        }
        newWidth -= parseInt(getComputedStyle(optsBox.querySelector('.link-dropdown__link')).paddingInlineStart, 10);
      } else {
        newWidth = parseInt(getComputedStyle(this.button).paddingInlineEnd, 10) + Math.ceil(this.button.querySelector('.link-dropdown__button-text').getBoundingClientRect().width);
      }
      setTimeout(() => {
        //this.button.style.width = `${newWidth}px`;
      }, 10);
    }

    if (doExpand) {
      this.open = true;
      this.addDismissListener();
    } else {
      this.open = false;
      this.removeDismissListener();
    }
  }

  addDismissListener() {
    this.dismissCallback = this.toggle.bind(this, true);
    document.addEventListener('click', this.dismissCallback);
  }

  removeDismissListener() {
    document.removeEventListener('click', this.dismissCallback);
    this.dismissCallback = null;
  }
};

window.customElements.define('sort-dropdown', SortDropdown);

// add a fullback
window.theme = theme || {};
theme.Shopify = theme.Shopify || {};

class DiamondsSearch extends HTMLElement {
  constructor() {
    super(); // Call the parent class's constructor
    this.form = this.querySelector('form#dimonds-search');
    this.grid = this.querySelector('.items-grid__container');
    const elongatedCushin = this.form.querySelector('[value*=" CUSHION"]');
    const regularCushion = this.form.querySelector('[value="CUSHION"]');
    const shapeInputs = Array.from(this.form.querySelectorAll('[name="shapes"]'));

    const typeInputs = this.form.querySelectorAll('[name="labgrown"]');

    const loadmoreBtn = this.querySelector('[data-action=load-more]');
    DiamondsSearch.fullSchema = JSON.parse(document.querySelector('[id="schema"]').textContent);

    const handleSubmitDebounce = DiamondsSearch.debounce(this.handleSubmit.bind(this), 300);

    this.form.addEventListener('submit', handleSubmitDebounce.bind(this));
    this.form.addEventListener('change', handleSubmitDebounce.bind(this));
    this.form.addEventListener('input', handleSubmitDebounce.bind(this));

    typeInputs.forEach((input) => input.addEventListener('change', this.hadnleTypeChange.bind(this)));

    loadmoreBtn.addEventListener('click', this.loadMoreHandler.bind(this));
    this.querySelectorAll('[data-action="reset"]').forEach((btn) => btn.addEventListener('click', this.resetFormHandler.bind(this)));

    try {
      this.initialDefaults = JSON.parse(this.dataset.searchFormDefaults);

      DiamondsSearch.setFormDefaults(this.initialDefaults);
    } catch (err) {}

    this.form.dispatchEvent(new Event('change'));

    // Add shape change handler
    shapeInputs.forEach((input) => input.addEventListener('change', this.handleShapeChange.bind(this)));
    const lastSelectedShape = shapeInputs.reverse().find((input) => input.checked);
    if (lastSelectedShape) {
      this.handleShapeChange({ target: lastSelectedShape });
    }

    this.updateTypesUrls();

    // Add page visibility event listener to handle back navigation
    document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));

    // Add pageshow event listener to handle page load from cache
    window.addEventListener('pageshow', this.handlePageShow.bind(this));
  }

  updateTypesUrls() {
    const searchParams = window.location.search;

    document.querySelectorAll('.diamonds-checkbox').forEach((el) => {
      el.href = `${el.href}${searchParams}`;
    });
  }

  static renderItems({ items = [], resetContent = true } = {}) {
    const grid = document.querySelector('#diamonds-items-grid__inner');

    if (resetContent) {
      DiamondsSearch.clearGridContents();
    }

    items.forEach((item) => {
      const diamondCardHTML = this.generateDiamondCardHTML(item);
      grid.insertAdjacentHTML('beforeend', diamondCardHTML);
    });

    const error = document.querySelector('.diamonds-items__error-message');
    if (items.length === 0) {
      if (!error) {
        const html = `
          <div class="diamonds-items__error-message">
            <p class="error-message center">No diamonds found.</p>
          </div>
        `;
        grid.insertAdjacentHTML('afterend', html);
      } else {
        error.style.display = 'block';
      }
    } else {
      if (error) error.remove();
    }

    DiamondsSearch.renderActives();
  }

  static generateDiamondCardHTML(item) {
    const {
      diamond: {
        certificate: { shape, presentation_shape, carats, color, f_color, clarity, cut, certNumber, lab, labgrown_type, length, width, depth },
        video,
        v360,
        image,
      },
      GBP_markup_price,
      renderImage,
    } = item;

    const renderVideo = video || item.diamond.certificate.video;
    const ratio = DiamondsSearch.getRatio(length, width, depth);
    //const placeholderImg = window.placeholder_images[shape] || window.placeholder_images['CUSHION'];
    const imgSrc = renderImage; //|| placeholderImg;
    const imgClass = renderImage ? 'card-diamond-img' : 'card-placeholder-img';
    const certificateType = item.diamond.certificate.lab;

    const title = `${presentation_shape} ${carats} Carat <span class="diamond-card__title-price"> <span data-price="${GBP_markup_price}">${DiamondsSearch.formatMoney(
      GBP_markup_price,
      window.theme.money_format_no_decimals
    )}</span> inc VAT</span>`;

    const type = item.diamond.certificate.labgrown ? 'labgrown' : 'natural';

    return `
      <div class="diamond-card" data-cert-number="${certNumber}">
        <figure class="diamond-card__media-wrapper">
          <div class="diamond-card__media">
            <img
              src="${imgSrc}"
              class="${imgClass}"
              alt="${shape || 'NA'}"
              height="100"
              width="100"
              loading="lazy">
            ${
              renderVideo
                ? `<iframe width='500' loading="lazy" height='500' frameborder='0' allow='accelerometer; autoplay;' data-src='${renderVideo.replace(
                    '/500/500',
                    ''
                  )}' autoplay ></iframe>`
                : ''
            }
          </div>
          <div class="diamond-card__top-labels">
            ${lab === 'GIA' && false ? `<span class="diamond-card__top-label diamond-card__top-label--lab-grown">${lab}</span>` : ''}
            ${labgrown_type ? `<span class="diamond-card__top-label">${labgrown_type}</span>` : ''}
          </div>
        </figure>
        <div class="diamond-card__content">
          <div class="diamond-card__content-top-outer">
            <div class="diamond-card__content-top">
              <h3 class="diamond-card__title">${title}</h3>
            </div>
            ${certificateType && certificateType === 'IGI' ? `<img src="${window.igi_logo_small}" alt="${certificateType} logo" class="diamond-card__IGI-logo">` : ''}
            ${certificateType && certificateType === 'GIA' ? `<img src="${window.gia_logo_small}" alt="${certificateType} logo" class="diamond-card__GIA-logo">` : ''}
          </div>
          <div class="diamond-card__content-details-wrapper">
            <div class="diamond-card__content-details">
              <p class="diamond-card__details"><span>Color</span> ${f_color || color}</p>
              <p class="diamond-card__details"><span>Clarity</span> ${clarity}</p>
              <p class="diamond-card__details"><span>Cut</span> ${cut}</p>
              <p class="diamond-card__details"><span>R.</span> ${ratio}</p>
            </div>
          </div>
          <div class="diamond-card__actions" data-cert-number="${certNumber}">
            <diamond-actions data-shape="${presentation_shape}" data-cert-number="${certNumber}" data-type="${type}" data-handle="diamond-${certNumber}">
              <a class="button" type="button" data-action="select" label="Select diamond">select</a> 
            </diamond-actions>
            <diamond-actions data-shape="${presentation_shape}" data-cert-number="${certNumber}"> 
              <a class="button outline" type="button" outline data-action="more-info" label="View more info">more info</a> 
            </diamond-actions>
          </div>
        </div>
      </div>
    `;
  }

  static renderActives() {
    const activesBtns = Array.from(document.querySelectorAll('diamonds-search .active-filters-inner .active-filters__input-btn'));
    const activesWrapper = document.querySelector('diamonds-search .active-filters-inner');
    const activeShapes = Array.from(document.querySelectorAll('diamonds-search [name="shapes"]:checked'));

    activesBtns.forEach((btn) => btn.remove());

    if (activeShapes.length === 0) return (activesWrapper.style.display = 'none');

    activesWrapper.style.display = 'block';

    const activeBtnsHTML = activeShapes.map((shape) => {
      const name = shape.getAttribute('name');
      const value = shape.getAttribute('value');
      return `<button class="active-filters__btn active-filters__input-btn" 
          onclick="document.querySelector('[name=${name}][value=${value}]').click()" 
          type="button">${value.toLowerCase()}</button>`;
    });
    // insert after start
    activesWrapper.insertAdjacentHTML('afterbegin', activeBtnsHTML.join(''));
  }

  hadnleTypeChange(evt) {
    evt.preventDefault();
    const currentType = evt.target.value;
    window.location.href = currentType == 'true' ? window.lapgrown_search_page_url : window.natural_search_page_url;
    return false;
    /* const defaults = currentType == 'true' ? JSON.parse(this.dataset.labgrownnDefaults) : JSON.parse(this.dataset.naturalDefaults);
    DiamondsSearch.setFormDefaults(defaults);
    this.form.dispatchEvent(new Event('change')); */
  }

  async handleSubmit(evt) {
    if (evt && evt.preventDefault) evt.preventDefault();
    if (evt && (evt.type === 'change' || evt.type === 'input')) {
      // clear offset when filters change
      this.querySelector('[name=offset]').value = 0;
      // delete the previous results
      DiamondsSearch.clearGridContents();
    }

    this.classList.add('loading');
    const action = window.diamonds_route + '/diamonds';
    const formData = new FormData(this.form);
    // Turn form data into URL params
    const url = new URLSearchParams(formData).toString();
    const data = DiamondsSearch.formDataToJson(this.form);

    // Cancel any ongoing fetch request
    if (this.abortController) {
      this.abortController.abort();
      console.log('Previous fetch request aborted');
    }

    // Create a new AbortController for the current request
    this.abortController = new AbortController();

    // Use a local variable to ensure only the latest response is processed
    const currentRequestSignal = this.abortController.signal;

    try {
      const response = await DiamondsSearch.renderFromFetch({
        data,
        url,
        action,
        signal: currentRequestSignal,
      });

      if (response?.ok && currentRequestSignal === this.abortController.signal) {
      } else {
        console.warn('Fetch request was not the latest; ignoring response.');
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('Fetch request aborted');
      } else {
        console.error('Fetch request failed:', error);
      }
    } finally {
      if (currentRequestSignal === this.abortController.signal) {
        this.classList.remove('loading');
      }
    }
  }

  static async renderFromFetch({ data, url, action, signal }) {
    console.log({ data });

    let response;
    try {
      response = await fetch(action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data,
          schema: DiamondsSearch.getQuerySchema(),
        }),
        signal, // Pass the AbortController's signal
      });
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('Fetch request aborted before completion.');
        return; // Exit early for aborted requests
      }
      throw error; // Re-throw other errors
    }

    // Explicit check for signal.aborted to ignore results from aborted requests
    if (signal.aborted) {
      console.warn('Fetch completed but request was aborted; ignoring results.');
      return;
    }

    if (!response.ok) {
      console.error(`Fetch failed with status: ${response.status}`);
      DiamondsSearch.errorHandler(response);
      return response;
    }

    const result = await response.json();

    DiamondsSearch.renderItems({
      items: result.items,
      resetContent: result.offset === 0,
    });

    DiamondsSearch.updateLoadmoreBtn({
      total_count: result.total_count,
      nivoda_original_total_count: result.nivoda_original_total_count,
      items: result.items,
    });

    const cartAttributesKey = document.querySelector('diamonds-search').dataset.cartAttributesKey;

    DiamondsSearch.updateCartAttrs({
      key: cartAttributesKey,
      value: data,
    });

    DiamondsSearch.filterData = [...DiamondsSearch.filterData, { result, url }];

    return response;
  }

  async loadMoreHandler(evt) {
    evt.preventDefault();
    const limit = this.querySelector('[name=limit]').value;
    const offsetInput = this.querySelector('[name=offset]');
    const offset = parseInt(offsetInput.value) + parseInt(limit);
    offsetInput.value = offset;
    // trigger the form submit not the input change event, as we want to keep the previous results
    this.form.dispatchEvent(new Event('submit'));
  }

  resetFormHandler(evt) {
    evt.preventDefault();
    const resetDefaults = JSON.parse(this.dataset.searchResetDefaults);
    const areShapesRadioType = this.form.querySelector('[name="shapes"]').type === 'radio';
    if (areShapesRadioType) {
      this.handleShapeChange({ target: this.form.querySelector('[name="shapes"]:checked') });
    } else {
      DiamondsSearch.setFormDefaults({
        ...resetDefaults,
        shapes: [],
      });
      this.dispatchPriceRangeReset();
    }
  }

  dispatchPriceRangeReset() {
    const priceRangeInputs = this.querySelectorAll('diamonds-price-range input.dc-price-range__input');
    priceRangeInputs.forEach((input) => {
      input.dispatchEvent(new Event('change'));
    });
  }

  handleShapeChange(event) {
    console.log('handleShapeChange', event);
    let input = event.target;
    const preselectedShape = this.getAttribute('data-url-based-shape');
    if (preselectedShape && this.querySelector(`[name="shapes"][value="${preselectedShape}"]`)) {
      input = this.querySelector(`[name="shapes"][value="${preselectedShape}"]`);
      // remove the data-url-based-shape attribute
      this.removeAttribute('data-url-based-shape');
      // save it in another attribute
      this.setAttribute('data-preselected-shape', preselectedShape);
    }

    // Get all currently selected shapes
    let selectedShapes = Array.from(this.form.querySelectorAll('[name="shapes"]:checked')).map((input) => input.value);

    // Check if a cushion shape is selected and if the current input is a cushion shape
    const isCushionShape = selectedShapes.some((shape) => shape.includes('CUSHION')) && input.value.includes('CUSHION');

    if (isCushionShape) {
      this._handleCushionShapeSelection(input, selectedShapes);
    } else {
      this._handleNonCushionShapeSelection(selectedShapes);
    }
  }

  _lockRatioInputs() {
    const ratioMinInput = this.form.querySelector('[name="ratio.from"]');
    // Add visual indication that ratio is locked
    ratioMinInput.closest('.filter-group').classList.add('filter-group--locked');
  }

  _unlockRatioInputs() {
    const ratioMinInput = this.form.querySelector('[name="ratio.from"]');
    ratioMinInput.closest('.filter-group').classList.remove('filter-group--locked');
  }

  /**
   * Handles selection of a cushion shape
   * @private
   */
  _handleCushionShapeSelection(input, selectedShapes) {
    // Lock ratio inputs by default
    this._lockRatioInputs();
    const cushionExactValue = input.value;

    // Uncheck all other shapes
    this.form.querySelectorAll('[name="shapes"]').forEach((item) => {
      if (item.value != cushionExactValue) {
        item.checked = false;
      }
    });

    // Set ratio based on cushion type
    const isElongatedCushion = cushionExactValue.includes('ELONGATED');
    const ratioMin = isElongatedCushion ? 1.25 : 0.5;
    const ratioMax = isElongatedCushion ? 6.0 : 1.2499;

    // Apply the new defaults
    const newDefaults = {
      ...this.initialDefaults,
      shapes: [cushionExactValue],
      'ratio.to': ratioMax,
      'ratio.from': ratioMin,
    };

    DiamondsSearch.setFormDefaults(newDefaults);
  }

  /**
   * Handles selection of a non-cushion shape
   * @private
   */
  _handleNonCushionShapeSelection(selectedShapes) {
    // Re-enable ratio inputs
    this._unlockRatioInputs();

    // Uncheck the cushion shapes
    this.form.querySelectorAll('[name="shapes"]').forEach((input) => {
      if (input.value.includes('CUSHION')) {
        input.checked = false;
      }
    });

    // Handle normal shape selection
    const newDefaults = {
      ...this.initialDefaults,
      shapes: selectedShapes.filter((shape) => !shape.includes('CUSHION')),
    };

    DiamondsSearch.setFormDefaults(newDefaults);
  }

  static errorHandler(response) {
    const grid = document.querySelector('#diamonds-items-grid__inner');
    const html = `
      <div class="diamonds-items__error-message">
        <p class="error-message center">An error occurred while fetching the data. Please try again.</p>
      </div>
    `;
    grid.insertAdjacentHTML('afterend', html);
    document.querySelector('#dimonds-search [data-action="load-more"]').style.display = 'none';
  }

  static updateLoadmoreBtn({ nivoda_original_total_count }) {
    const limit = +document.querySelector('#dimonds-search [name="limit"]').value;

    const loadmoreBtn = document.querySelector('#dimonds-search [data-action="load-more"]');
    loadmoreBtn.style.display = nivoda_original_total_count < limit ? 'none' : '';
  }

  static formDataToJson(form) {
    const formData = new FormData(form);
    const jsonObject = {};

    // Iterate over formData entries
    for (const [key, value] of formData.entries()) {
      //if (jsonObject[key] == undefined) debugger;
      // Check if the key already exists in the JSON object, or if the input is checkbox then convert it to an array
      if (key in jsonObject || (form.querySelector(`input[name="${key}"]`) && form.querySelector(`input[name="${key}"]`).type === 'checkbox')) {
        // Convert existing value to an array if not already
        if (!Array.isArray(jsonObject[key])) {
          jsonObject[key] = [jsonObject[key]];
        }
        jsonObject[key].push(value); // Add new value to array
      } else {
        jsonObject[key] = value; // Directly assign value
      }
    }

    // let's filter all arrays to remove undefined values
    Object.keys(jsonObject).forEach((key) => {
      if (Array.isArray(jsonObject[key])) {
        jsonObject[key] = jsonObject[key].filter((value) => value !== undefined);
      }
    });

    return jsonObject;
  }

  static getQuerySchema({ fullSchema = DiamondsSearch.fullSchema } = {}) {
    return Object.keys(fullSchema).reduce((acc, key) => {
      const entry = {
        type: fullSchema[key].type,
        graphqlField: fullSchema[key].graphqlField,
      };
      return Object.assign(acc, { [key]: entry });
    }, {});
  }

  static formatMoney(t, r = window.theme.money_format) {
    function e(t, r) {
      return void 0 === t ? r : t;
    }
    function a(t, r, a, o) {
      if (((r = e(r, 2)), (a = e(a, ',')), (o = e(o, '.')), isNaN(t) || null == t)) return 0;
      t = (t / 100).toFixed(r);
      var n = t.split('.');
      return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + a) + (n[1] ? o + n[1] : '');
    }
    'string' == typeof t && (t = t.replace('.', ''));
    var o = '',
      n = /\{\{\s*(\w+)\s*\}\}/,
      i = r || this.money_format;
    switch (i.match(n)[1]) {
      case 'amount':
        o = a(t, 2);
        break;
      case 'amount_no_decimals':
        o = a(t, 0);
        break;
      case 'amount_with_comma_separator':
        o = a(t, 2, '.', ',');
        break;
      case 'amount_with_space_separator':
        o = a(t, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        o = a(t, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        o = a(t, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        o = a(t, 0, ' ', '');
        break;
      case 'amount_with_apostrophe_separator':
        o = a(t, 2, "'", '.');
        break;
      case 'amount_with_decimal_separator':
        o = a(t, 2, '.', '.');
    }

    return i.replace(n, o);
  }

  static clearGridContents() {
    const grid = document.querySelector('#diamonds-items-grid__inner');
    Array.from(grid.children).forEach((node) => node.remove());
  }

  static async updateCartAttrs({ value, key }) {
    await fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      body: JSON.stringify({
        attributes: {
          [key]: value,
        },
      }),
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        //console.log('Cart updated', data);
      })
      .catch((error) => {
        console.error('Cart update failed:', error);
      });
  }

  static setFormDefaults(defaults) {
    const form = document.querySelector('form#dimonds-search');
    //form.reset();
    Object.keys(defaults).forEach((key) => {
      const input = form.querySelector(`[name="${key}"]`);
      const value = defaults[key];
      const exactInput = form.querySelector(`[name="${key}"][value="${value}"]:not(:disabled,[min])`);
      const option = form.querySelector(`[name="${key}"] option[value="${value}"]`);
      const sortOption = form.querySelector(`sort-dropdown [data-value="${value}"]`);
      if (input.name == 'labgrown') return;
      if (Array.isArray(value)) {
        // Handle multiple values (like shapes)
        value.forEach((v) => {
          const checkboxes = form.querySelectorAll(`input[name="${key}"]`);
          checkboxes.forEach((checkbox) => {
            checkbox.checked = value.includes(checkbox.value);
          });
        });
      } else {
        if (exactInput) return (exactInput.checked = true);
        if (sortOption) return sortOption.click();
        if (option) return (option.selected = true);
        if (input) input.value = value;
      }
    });

    // dispatch change event to the price range inputs
    const priceRangeInputs = form.querySelectorAll('diamonds-price-range input');
    priceRangeInputs.forEach((input) => {
      input.dispatchEvent(new Event('change', { bubbles: true })); // make sure we trigger the change event on the form
    });
  }

  static getRatio(length, width, depth) {
    // first turn it to Number and make if fixed to 2 deceimal
    length = Number(length).toFixed(2);
    width = Number(width).toFixed(2);
    depth = Number(depth).toFixed(2);
    return (length / width).toFixed(2);
  }

  static debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  // Common method to refresh the search
  refreshSearch() {
    console.log('refreshSearch');
    // Reset the loading state if it's stuck
    this.classList.remove('loading');

    // Clear any existing results
    DiamondsSearch.clearGridContents();

    // Reset the offset to 0
    this.querySelector('[name=offset]').value = 0;

    // Trigger a new search
    this.form.dispatchEvent(new Event('change'));
  }

  // Handle page visibility changes (when user returns from another page)
  handleVisibilityChange() {
    if (document.visibilityState === 'visible') {
      this.refreshSearch();
    }
  }

  // Handle page load from cache (bfcache)
  handlePageShow(event) {
    // Check if the page was loaded from the browser cache (bfcache)
    if (event.persisted) {
      this.refreshSearch();
    }
  }
}

// Define the custom element
customElements.define('diamonds-search', DiamondsSearch);
DiamondsSearch.filterData = [];

const ToggleTarget = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.toggleOpen.bind(this));
    this.addEventListener('keyup', this.handleKeyUp.bind(this));
    if (this.dataset.toggleCloseLabel) {
      this.dataset.toggleOpenLabel = this.innerHTML;
    }
  }

  /**
   * Handles 'keyup' events on the document.
   * @param {object} evt - Event object.
   */
  handleKeyUp(evt) {
    if (evt.key === 'Enter') this.toggleOpen(evt);
  }

  /**
   * Opens or closes the target element.
   * @param {object} evt - Event object.
   */
  toggleOpen(evt) {
    if (evt.target?.tagName === 'LABEL' || evt.target.tagName === 'INPUT') return;
    evt.preventDefault();

    const target = document.querySelector(this.dataset.toggleTarget);
    const transCont = target.querySelector('.toggle-target-container');
    const doCollapse = !target.classList.contains('toggle-target--hidden');
    const transitionDuration = parseFloat(getComputedStyle(target).transitionDuration) * 1000;

    if (!target.classList.contains('toggle-target--in-transition')) {
      if (doCollapse) {
        this.classList.add('toggle-target-toggler--is-hidden');
        target.classList.add('toggle-target--in-transition', 'toggle-target--hiding');
        target.style.height = `${transCont.clientHeight}px`;
        target.style.opacity = 1;

        if (this.dataset.toggleCloseLabel) {
          this.innerHTML = this.dataset.toggleOpenLabel;
        }

        setTimeout(() => {
          target.style.height = 0;
          target.style.opacity = 0;

          setTimeout(() => {
            target.classList.add('toggle-target--hidden');
            target.classList.remove('toggle-target--in-transition', 'toggle-target--hiding');
            target.style.height = '';
            target.style.opacity = '';
          }, transitionDuration);
        }, 10);
      } else {
        this.classList.remove('toggle-target-toggler--is-hidden');
        target.classList.add('toggle-target--in-transition', 'toggle-target--revealing');
        target.style.height = 0;
        target.style.opacity = 0;
        target.style.display = 'block';

        if (this.dataset.toggleCloseLabel) {
          this.innerHTML = this.dataset.toggleCloseLabel;
        }

        setTimeout(() => {
          target.style.height = `${transCont.clientHeight}px`;
          target.style.opacity = 1;

          setTimeout(() => {
            target.classList.remove('toggle-target--hidden', 'toggle-target--in-transition', 'toggle-target--revealing');
            target.style.height = '';
            target.style.opacity = '';
            target.style.display = '';
          }, transitionDuration);
        }, 10);
      }
    }
  }
};

window.customElements.define('toggle-target', ToggleTarget);

class ColorTypeToggler extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form');
    this.allColorInputs = this.form.querySelectorAll(this.dataset.colorInputsSelector);
    const debounceToggleColorType = DiamondsSearch.debounce(this.toggleColorType.bind(this), 300);
    this.addEventListener('change', debounceToggleColorType.bind(this));
    document.querySelector('#dimonds-search').addEventListener('change', debounceToggleColorType.bind(this));

    setTimeout(() => {
      if (this.initted) return;
      this.toggleColorType();
      this.initted = true;
    }, 100);
  }

  toggleColorType(event) {
    //console.log('toggleColorType', event?.detail?.fromColorTypeToggler);
    // return if the event is from the color type toggler
    if (event?.detail?.fromColorTypeToggler) return;
    if (this.blocked) return;

    //evt.preventDefault();
    const activeInput = this.querySelector('input:checked');
    const targetSelector = activeInput.dataset.target;

    this.allColorInputs.forEach((input) => {
      input.setAttribute('disabled', '');
    });

    this.form.querySelectorAll(targetSelector).forEach((target) => {
      target.removeAttribute('disabled');
    });
    if (this.form.querySelector(targetSelector)) {
      this.blocked = true;
      setTimeout(() => {
        this.blocked = false;
      }, 400);
      this.form.querySelector(targetSelector).dispatchEvent(
        new Event('change', {
          bubbles: true,
          // add flag to track it
          detail: { fromColorTypeToggler: true },
        })
      );
    }
  }
}

window.customElements.define('color-type-toggler', ColorTypeToggler);

class StickyFilters extends HTMLElement {
  constructor() {
    super();
    const toggleBtns = Array.from(document.querySelectorAll('[data-action="toggle-sticky-filters"]'));
    const shade = document.querySelector('.sticky-filters-page-shade');
    const itemsGrid = document.querySelector('.diamonds-items-grid');

    [...toggleBtns, shade].forEach((btn) => {
      btn.addEventListener('click', this.toggleStickyFilters.bind(this));
    });

    // once user scroll to touch the itemsGrid then let's remove the display none from the sticky filters
    // but make it none again if the user scroll up
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.style.display = '';
        } else {
          this.style.display = 'none';
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      }
    );

    observer.observe(itemsGrid);
  }

  toggleStickyFilters(evt) {
    evt.preventDefault();
    const filters = document.querySelector('diamonds-search .filters');
    const isStickyOpen = document.documentElement.classList.contains('sticky-filters--open');
    if (!isStickyOpen) {
      this.documentHeight = document.body.scrollHeight;
      document.body.style.height = `${this.documentHeight}px`;
    }
    document.documentElement.classList.toggle('sticky-filters--open');
    if (isStickyOpen) document.body.style.height = '';
  }
}

window.customElements.define('sticky-filters', StickyFilters);

// Lazy load iframes on hover
document.addEventListener('DOMContentLoaded', function () {
  // Function to load iframe if needed
  function loadIframeIfNeeded(element) {
    const mediaElement = element.closest('.diamond-card');
    if (mediaElement) {
      const iframe = mediaElement.querySelector('iframe[data-src]');
      if (iframe && !iframe.src) {
        iframe.src = iframe.dataset.src;
        iframe.removeAttribute('data-src');
      }
    }
  }

  // Handle hover for desktop
  document.addEventListener('mouseover', function (e) {
    loadIframeIfNeeded(e.target);
  });

  // Handle touch for mobile
  document.addEventListener('touchstart', function (e) {
    loadIframeIfNeeded(e.target);
  });

  // Handle click for all devices
  document.addEventListener('click', function (e) {
    loadIframeIfNeeded(e.target);
  });
});
